import ResponseListContainer from '../../containers/responseList/responseList';

function ResponseList() {
  return <ResponseListContainer />;
}

export default ResponseList;
